exports.f = {}.propertyIsEnumerable;



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.6.2@core-js/library/modules/_object-pie.js
// module id = 25
// module chunks = 0